module.exports = __webpack_public_path__ + "img/sound-on.55cddc75.svg";